import { put } from 'redux-saga/effects';

import { InsighttNotification } from '../../helpers/insightt-notification';
import CompanyActions from '../actions/company.actions';

export function* getCompanyDataRequest(api) {
  const response = yield api.getCompanyData();
  if (response && response.ok) {
    yield put(CompanyActions.getCompanyDataSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get company data', response);
    yield put(CompanyActions.getCompanyDataFailure());
  }
}
